export const mutateSearchKeys = {
  triggerExportToCsv: ['exportToCsv'] as const
};
